import React, { useEffect, useState } from "react";
import performRequest from "../../api/request";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import { useNavigate } from "react-router";

const SalesDailyReport = ({ trackFrom }) => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    performRequest(
      "GET",
      `/allTablesCount/getLeadsDetails/?dateFrom=${trackFrom}`
    )
      .then((res) => {
        if (res.status === 200) {
          let dt = res.data?.data;
          dt = dt?.sort((a, b) => b.answered - a.answered);
          setData(dt);
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [trackFrom]);

  return (
    <div
      className={
        trackFrom != null
          ? "page-wrapper"
          : "page-wrapper  text-white min-vh-100"
      }
    >
      <div className={trackFrom != null ? "" : "m-4"}>
        {trackFrom == null && (
          <div className="text-center mb-4">
            <h1 className="display-4 text-dark fw-bold">
              Sales Team Performance Daily Report
            </h1>
            <div
              onClick={() => navigate("/i-dashboard")}
              className="text-secondary fs-1 d-flex align-items-center justify-content-center gap-2 cursor-pointer"
            >
              <span className="status-indicator status-green status-indicator-animated">
                <span className="status-indicator-circle"></span>
                <span className="status-indicator-circle"></span>
                <span className="status-indicator-circle"></span>
              </span>

              <p className="mb-0">Live dashboard</p>
            </div>
          </div>
        )}

        <div className={trackFrom != null ? "" : "card"}>
          <div
            className={
              trackFrom != null ? "table-responsive" : "table-responsive fs-1"
            }
          >
            <table className="table table-vcenter table-striped table-hover text-center">
              <thead className={trackFrom != null ? "" : "table-dark"}>
                <tr>
                  <th
                    className={
                      trackFrom != null ? "text-start" : "text-start fs-3"
                    }
                  >
                    Employee
                  </th>
                  <th className={trackFrom != null ? "" : "fs-3"}>Calls</th>
                  <th className={trackFrom != null ? "" : "fs-3"}>Unique</th>
                  <th className={trackFrom != null ? "" : "fs-3"}>Ans</th>
                  <th className={trackFrom != null ? "" : "fs-3"}>FL Calls</th>
                  <th className={trackFrom != null ? "" : "fs-3"}>Ph Call</th>
                  <th className={trackFrom != null ? "" : "fs-3"}>WA</th>
                  <th className={trackFrom != null ? "" : "fs-3"}>Quotes</th>
                  <th className={trackFrom != null ? "" : "fs-3"}>Leads</th>
                  <th className={trackFrom != null ? "" : "fs-3"}>Duration</th>
                  <th className={trackFrom != null ? "" : "fs-3"}>SI</th>
                  <th className={trackFrom != null ? "" : "fs-3"}>FL taken</th>
                  <th className={trackFrom != null ? "" : "fs-3"}>
                    Fl Pending
                  </th>
                  {/* <th>In</th>
                  <th>Out</th>
                  <th>Miss</th>
                  <th>Attempt</th>
                  <th>Follow Ups</th>
                  <th>Done</th>
                  <th>Pending</th> */}
                </tr>
              </thead>
              <tbody>
                {data?.map((user) => (
                  <tr key={user.id}>
                    <td className="text-start">
                      <div className="fw-bold">{user.userName}</div>
                      {/* <small className="text-secondary">{user.email}</small> */}
                    </td>

                    <td>{user.totalCalls}</td>
                    <td>{user.uniqueCalls}</td>
                    <td>
                      <span className="badge bg-green-lt">{user.answered}</span>
                    </td>
                    <td>{user.followUpCalls}</td>
                    <td>{user.totalCalls - user.whatsappCalls}</td>
                    <td>{user.whatsappCalls}</td>
                    <td>{user.quotations}</td>
                    <td>
                      <span className="badge bg-green-lt">
                        {user.leadsCreated}
                      </span>
                    </td>
                    <td>{user.totalDuration}</td>
                    <td>{user.siteInspections}</td>
                    <td>{user.completedFollowupsCount}</td>
                    <td>
                      <span className="badge bg-red-lt">
                        {user.pendingFollowupsCount}
                      </span>
                    </td>

                    {/* <td>
                      <span className="badge bg-cyan-lt">{user.inbound}</span>
                    </td>

                    <td>
                      <span className="badge bg-orange-lt">
                        {user.outbound}
                      </span>
                    </td>

                    <td>
                      <span className="badge bg-red-lt">{user.unanswered}</span>
                    </td>

                    <td>{user.attempted}</td>
                    <td>{user.followUpToday}</td>

                    <td>
                      <span className="badge bg-green">
                        {user.completedFollowupsCount}
                      </span>
                    </td>

                    <td>
                      <span className="badge bg-red">
                        {user.pendingFollowupsCount}
                      </span>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

function Metric({ title, value, color }) {
  return (
    <div className="col-6">
      <div className={`card card-sm bg-${color}-lt`}>
        <div className="card-body text-center">
          <div className="h1 mb-1 fw-bold">{value}</div>

          <div className="text-secondary fw-semibold">{title}</div>
        </div>
      </div>
    </div>
  );
}

export default SalesDailyReport;
